import React from 'react';
import styled from 'styled-components';
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share';

import {
  CustomFacebookIcon,
  CustomLinkedinIcon,
  CustomTwitterIcon,
} from '@/core/components/SocialMediaIcons';

import { useIsClient } from '@/utils/hooks/useIsClient';

interface IconsWrapperProps {
  customIcons: boolean;
}

const IconsWrapper = styled.div<IconsWrapperProps>`
  display: flex;

  button {
    margin-right: ${props => (props.customIcons ? '25px' : '5px')};
  }

  button:last-child {
    margin-right: 0;
  }
`;

interface ShareIconsProps {
  customIcons?: boolean;
  textcolor?: string;
  uuid: string | Array<string> | undefined;
}

export const ShareIcons = ({
  customIcons,
  textcolor,
  uuid,
}: ShareIconsProps) => {
  const isClient = useIsClient();

  return (
    <IconsWrapper customIcons={!!customIcons}>
      {isClient && typeof (uuid) === 'string' && (
        <>
          <FacebookShareButton url={`${window.location.origin}/${uuid}`}>
            {!customIcons ?
              (
                <FacebookIcon
                  borderRadius={16}
                  size={32}
                />
              ) :
              (
                <CustomFacebookIcon textcolor={textcolor || '#fff'} />
              )
            }
          </FacebookShareButton>
          <TwitterShareButton url={`${window.location.origin}/${uuid}`}>
            {!customIcons ?
              (
                <TwitterIcon
                  borderRadius={16}
                  size={32}
                />
              ) :
              (
                <CustomTwitterIcon textcolor={textcolor || '#fff'} />
              )
            }
          </TwitterShareButton>
          <LinkedinShareButton url={`${window.location.origin}/${uuid}`}>
            {!customIcons ?
              (
                <LinkedinIcon
                  borderRadius={16}
                  size={32}
                />
              ) :
              (
                <CustomLinkedinIcon textcolor={textcolor || '#fff'} />
              )
            }
          </LinkedinShareButton>
        </>
      )}
    </IconsWrapper>
  );
};

ShareIcons.defaultProps = {
  customIcons: false,
  textcolor: null,
};
